<!-- 模块-充值油卡 -->
<template>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>充值油卡</span>
      <van-button type="default" round size="small" @click="ifShow = false">返 回</van-button>
    </div>

    <v-touch class="popup_body" @swiperight="ifShow = false">
      <van-cell center :title="'No.' + data.card_no" :label="data.type_name" :value="data.money" value-class="money" />

      <van-cell-group style="margin-top: 5px;">
        <van-field
          readonly
          v-model="input_money"
          label="充值金额:"
          placeholder="请选择或输入充值金额"
          @click="show_keyboard = true"
        />

        <van-row gutter="20" style="padding: 15px 15px 5px 15px">
          <van-col span="8" v-for="(val, key) in limit_data" :key="key" style="margin-bottom: 10px;">
            <van-button class="limit" plain block type="info" @click="choose_limit(val)">{{val}}</van-button>
          </van-col>
        </van-row>
      </van-cell-group>

      <van-cell-group style="margin-top: 5px;">
        <van-cell center title="实际到账:" default>
          <span class="van-submit-bar__price">
            ￥<span style="font-size: 18px;">{{show_money(2, money)}}</span>.{{show_money(3, money)}}
          </span>
        </van-cell>
      </van-cell-group>

      <van-cell-group style="margin-top: 5px;">
        <van-cell center title="优惠活动:" default title-class="dis_title" value-class="gray" :value=" dis.length<=0 ? '暂无':'' "/>
        <template v-if="dis.length>0">
          <van-cell v-for="(item, i) in dis" :key="i" :title="mz(item)" :border="false" />
        </template>
      </van-cell-group>

      <van-submit-bar label="需付：" :price="show_money(1, input_money)" button-text="充值油卡" :loading="ifOn" :disabled="ifOn" @submit="on()" />
    </v-touch>

    <!-- 数字键盘 -->
    <van-number-keyboard
      safe-area-inset-bottom
      :hide-on-click-outside="false"
      theme="custom"
      :show="show_keyboard"
      :extra-key="['00', '.']"
      close-button-text="完成"
      @blur="show_keyboard = false"
      @input="keyboard_on"
      @delete="keyboard_del"
    />

    <!-- 子组件 -->
    <pay ref="pay" @result="pay_result" />
  </van-popup>
</template>

<style lang="scss" scoped>
  .money {
    font-size: 16px;
    color: #303133;
  }

  .limit {
    border-radius: 5px;
    font-size: 16px;
  }

  .dis_title {
    color: red;
  }
  .gray{
    color:#969799;
  }
</style>

<script>
import pay from '@/components/pay'

export default {
  name: 'card_recharge',
  components: {pay},
  data () {
    return {
      ifShow: false,
      ifOn: false,
      show_keyboard: false,
      data: false,
      limit_data: [
        100, 200, 300, 500, 1000, 2000
      ],
      input_money: '',
      money: 0,
      order_id: '',
      dis: [] // 优惠活动
    }
  },

  methods: {
    // 显示弹层
    show (data) {
      this.data = data
      this.ver_msg()
      this.order_id = ''
      this.input_money = ''
      this.money = ''
      this.sel_dis()
    },

    // 满赠
    mz (e) {
      let str = ''
      if (e.money > 0 && !e.gr_name) {
        str += '充值满 ' + e.tigger + ' 赠 ' + e.money + '元'
      }
      if (e.money <= 0 && e.gr_name) {
        str += '充值满 ' + e.tigger + ' 赠礼品 ' + e.gr_name
      }

      if (e.money > 0 && e.gr_name) {
        str += '充值满 ' + e.tigger + ' 赠 ' + e.money + '元，加礼品 “' + e.gr_name + '"'
      }
      return str
    },

    // 判断油卡信息是否完整
    ver_msg () {
      let msg = this.data.msg
      if (msg.pho === '' || msg.certificate.num === '') {
        let that = this
        this.$dialog({
          title: '需完善油卡信息',
          message: '为了保证您的资金安全，请完善该油卡信息',
          confirmButtonText: '去完善',
          showCancelButton: true
        }).then(() => {
          that.$emit('show_msg', that.data)
        }).catch(() => {})
      } else {
        this.ifShow = true
      }
    },

    // 处理显示金额
    show_money (type, val) {
      if (val === '') { val = 0 }
      val = parseFloat(val) * 100
      if (type === 1) {
        return val
      }
      val = val.toFixed(0)
      if (type === 2) {
        return val === '0' || parseInt(val) < 100 ? '0' : val.substr(0, val.length - 2)
      }
      if (type === 3) {
        val = val === '0' ? '00' : val.substr(val.length - 2)
        if (val.length === 1) {
          return '0' + val
        } else {
          return val
        }
      }
    },

    // 数字键盘输入
    keyboard_on (val) {
      // 过滤错误输入
      let m = this.input_money
      if (m.length === 0 && val === '.') {
        return
      }
      if (m.indexOf('.') >= 0 && val === '.') {
        return
      }
      if (m.indexOf('.') > 0 && m.substr(m.indexOf('.')).length > 2) {
        return
      }
      if (m === '0' && val !== '.') {
        return
      }
      this.input_money += val.toString()
      this.sweep()
    },

    // 数字键盘删除
    keyboard_del () {
      this.input_money = this.input_money.substr(0, this.input_money.length - 1)
      this.sweep()
    },

    // 选中预设金额
    choose_limit (val) {
      this.input_money = val.toString()
      this.sweep()
    },

    // 实时获取输入金额
    sweep () {
      this.money = this.input_money
      this.count_money()
    },

    // 提交充值
    on () {
      if (this.input_money < 0.01) {
        return this.$notify({ type: 'warning', message: '充值金额无效' })
      }

      // 生成订单
      this.ax(this, 'into_rw', {card_id: this.data.card_id, money: this.input_money}, (res) => {
        if (res.err_num === 0) {
          res.data.type = 2
          this.$refs.pay.show(res.data)
        }
      }, 'on')
    },

    // 支付结果
    pay_result (res) {
      if (res.res) {
        this.$emit('up_data')
        this.ifShow = false
      }
    },

    // 计算实际到账金额
    count_money () {
      if (this.dis.length > 0) {
        let money = parseFloat(this.money)
        this.dis.forEach((item) => {
          if (money >= parseFloat(item.tigger)) {
            this.money = money + parseFloat(item.money)
          }
        })
      }
    },

    // 查询充值优惠
    sel_dis () {
      // 生成订单
      this.ax(this, 'wx_card_sel_disc_off_recharge',
        {
          s_id: this.data.s_id,
          card_id: this.data.card_id
        },
        (res) => {
          if (res.err_num === 0) {
            this.dis = res.data
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/recharge.vue